define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/riq-dropdown/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/riq-dropdown/1.0.0/index.css',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/riq-dropdown/1.0.0/js/vm-service/index',
  'readingiq-src/js/riq-js/riq-dropdown/1.0.0/js/state-service/index',
  'readingiq-src/js/riq-js/aofl-panel/1.0.0/index'
  /* eslint-enable */
], function riqDropdownModule(app, html, css, aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  app.registerComponent('riqDropdown', {
    template: html,
    transclude: {
      button: 'riqDropdownButton',
      content: 'riqDropdownContent'
    },
    bindings: {
      id: '@'
    },
    controller: 'RiqDropdownController'
  });

  app.registerController('RiqDropdownController', [
    '$scope',
    '$element',
    'compileService',
    'riqDropdownVmService',
    'riqDropdownStateService',
    function RiqDropdownController(
      $scope,
      $element,
      compileService,
      riqDropdownVmService,
      riqDropdownStateService
    ) {
      var _this = this;

      storeService.addState(riqDropdownStateService);

      var mapProperties = function mapProperties() {
        var state = storeService.getState();
        _this.active = state[riqDropdownStateService.namespace][_this.id];
      };

      var unsubscribe = storeService.subscribe(function subscribe() {
        $scope.$applyAsync(mapProperties);
      });

      _this.$onInit = function init() {
        _this.id = riqDropdownVmService.add(_this.id);
        _this.toggle = riqDropdownVmService.toggle;

        mapProperties();
      };

      _this.$onDestroy = function onDestroy() {
        riqDropdownVmService.remove(_this.id);
        unsubscribe();
      };

      compileService.compile(
        {
          css: css
        },
        $scope,
        $element
      );
    }
  ]);
});
